import { GET_ORDER_SHIPPING_GROUPS_INFO } from '../actionTypes/OrderActionTypes';

export default function OrderShippingGroupsInfoReducer(state = [], action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case GET_ORDER_SHIPPING_GROUPS_INFO:
            return action.payload;
        default:
            return state;
    }
}
